export default {
  LOGIN_LOADING: '@HOME_LOGIN_LOADING',
  LOGIN_SUCCESS: '@HOME_LOGIN_SUCCESS',
  LOGIN_ERROR: '@HOME_LOGIN_ERROR',
  GET_USER_TOKEN_SUCCESS: '@HOME_GET_USER_TOKEN_SUCCESS',
  GET_USER_TOKEN_ERROR: '@HOME_GET_USER_TOKEN_ERROR',
};
